import React from 'react'
import styled from 'styled-components'

interface Props {
  label: string
  color: string
}

const ColouredBox = styled.span`
  height: 10px;
  width: 20px;
  margin-right: 10px;
  display: inline-block;
  background: ${props => props.color};
`

const DoughnutColuredLabel = ({ label, color }: Props): React.ReactElement => (
  <React.Fragment>
    <ColouredBox color={color} />
    {label}
  </React.Fragment>
)

export default DoughnutColuredLabel
